import { useAppSelector } from '../redux/hooks';
import type { SessionUser } from '../types/auth';

/**
 * Custom uploaded photo (jobForm) overrides OAuth `picture` / `image` everywhere we show the user avatar.
 */
export function useEffectiveUserProfilePhoto(user: SessionUser | null | undefined): string | null {
  const custom = useAppSelector((s) => s.jobForm.profilePhotoDataUrl?.trim() ?? '');
  if (custom) return custom;
  if (!user) return null;
  return user.image || user.picture || null;
}
